'use client'

import React from 'react'
import excel from 'exceljs'
import { saveAs } from 'file-saver'

import { Button } from '@/components/ui'
import { TablerFileTypeXls } from '@/components/ui/icons'

interface ExportOrderTaxesReportProps {
  items: any[]
}

export const ExportOrderTaxesReport = ({
  items,
}: ExportOrderTaxesReportProps) => {
  const exportReport = async () => {
    try {
      const workbook = new excel.Workbook()
      const worksheet = workbook.addWorksheet('Stock Report')

      // Define columns with more formatting options
      worksheet.columns = [
        { header: 'Invoice', key: 'invoice', width: 30 },
        { header: 'Tax Name', key: 'taxName', width: 15 },
        { header: 'Tax Amount', key: 'taxAmount', width: 15 },
      ]

      // Style the header row
      worksheet.getRow(1).font = { bold: true }
      worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }

      // Add rows with formatting
      for (const item of items) {
        const row = worksheet.addRow({
          invoice: item.invoice_number,
          taxName: item.tax_name,
          taxAmount: item.tax_amount,
        })

        // Set alignment for each cell in the row
        row.alignment = { vertical: 'middle', horizontal: 'left' }
        row.getCell('invoice').alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
        row.getCell('taxName').alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
        row.getCell('taxAmount').alignment = {
          vertical: 'middle',
          horizontal: 'center',
        }
      }

      // Auto-fit columns
      for (const column of worksheet.columns) {
        column.width = column.width || 15
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const fileName = `stock-report-${new Date().toISOString().split('T')[0]}.xls`
      saveAs(blob, fileName)
    } catch (error) {
      console.error('Error exporting report:', error)
    }
  }

  return (
    <div>
      <Button size="sm" variant="outline" onClick={exportReport}>
        <TablerFileTypeXls className="!size-5" />
        Export Report
      </Button>
    </div>
  )
}
